import React, { useEffect, useRef, useState } from "react";
import Button from "@material-ui/core/Button";
import PublishIcon from "@material-ui/icons/Publish";
import axios from "axios";
import useConfirm from "../../components/Control/useConfirm";
import { DivStyled } from "../Departments/container.style";

const AddEditCategory = ({ id, setIsCategoryModal }) => {
  const [categoryData, setCategoryData] = useState({});
  const inputElement = useRef(null);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    "CATEGORY",
    `Are you sure you want to ${id ? "update" : "save"} this?`,
  );

  useEffect(() => {
    if (inputElement.current) {
      inputElement.current.focus();
    }
  }, []);

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/specialProcess/category/${id}`)
        .then((res) => setCategoryData(res.data))
        .catch((err) => console.log(err));
    }
  }, [id]);

  function handleCategoryData(e) {
    setCategoryData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  const handleSubmit = async () => {
    if (!categoryData.category_name) {
      alert("Category Name is required");
      return;
    }
    const ans = await confirmSubmit();
    if (!ans) return;

    if (id) {
      await axios
        .put(`/api/specialProcess/category/${id}`, categoryData)
        .then(() => setIsCategoryModal(false))
        .catch((err) => console.log(err));
    } else {
      await axios
        .post("/api/specialProcess/category", categoryData)
        .then(() => setIsCategoryModal(false))
        .catch((err) => console.log(err));
    }
  };

  return (
    <section className="root-admin">
      <div
        className="btn_save"
        style={{
          position: "absolute",
          right: "150px",
          top: "9px",
        }}
      >
        <Button
          type="submit"
          variant="outlined"
          size="large"
          style={{ color: "#e9e9e9" }}
          startIcon={<PublishIcon />}
          onClick={handleSubmit}
        >
          {id ? "UPDATE" : "SUBMIT"}
        </Button>
      </div>
      <DivStyled>
        <label htmlFor="category_name">Category Name:</label>
        <input
          type="text"
          id="category_name"
          name="category_name"
          ref={inputElement}
          defaultValue={categoryData?.category_name}
          onBlur={handleCategoryData}
        />
      </DivStyled>
      <DivStyled>
        <label htmlFor="remarks">Remarks:</label>
        <input
          type="text"
          id="remarks"
          name="remarks"
          defaultValue={categoryData?.remarks}
          onBlur={handleCategoryData}
        />
      </DivStyled>
      <DialogSubmit isSubmitContent={false} />
    </section>
  );
};

export default AddEditCategory;
